<template>
  <div class="sidebar-layout page p-2" :style="$slots['footer-buttons'] ? 'margin-bottom: 4em;' : ''">
    <page-header class="mb-2" :title="title">
      <template v-slot:title>
        <slot name="title"></slot>
      </template>
      <template v-slot:buttons>
        <slot name="buttons"></slot>
      </template>
    </page-header>
    <div class="form-content">
      <div class="row">
        <div class="col-md-3 left-navbar">
          <div class="outer-container">
            <h6 v-if="label">{{ label }}</h6>
            <h6 v-else-if="title">{{ title }}</h6>
            <slot v-else name="title"></slot>
            <slot name="sidebar"></slot>
          </div>
        </div>
        <div class="col-md-9 content-placeholder">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <div class="form-footer text-right" v-if="$slots['footer-buttons']">
      <slot name="footer-buttons">
      </slot>
    </div>
  </div>
</template>

<script>
  import PageHeader from "../../page-header/PageHeader";

  export default {
    name: "SidebarLayout",
    components: {PageHeader},
    props: {
      title: {
        type: String,
        required: false
      },
      label: {
        type: String,
        required: false
      }
    },
    data() {
      return {};
    },
    computed: {},
    methods: {}
  }
</script>

<style lang="scss">
  @import "../../../scss/variables";
  @import "../../../../scss/variables";

  .sidebar-layout {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: $secondary;
    overflow-y: auto;

    .form-content {
      flex: 1;
      //padding: 1em 15px 1em 15px;
    }

    .form-footer {
      right: 0;
      display: flex;
      box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);
      position: absolute;
      bottom: 0;
      background-color: $white;
      width: 100%;
      height: 4em;
      align-items: center;
      justify-content: flex-end;
      padding: 0 2em;
    }

    .form-header {
      margin: $sided-layout-main-header-margin;
      border-radius: $sided-layout-main-header-radius;
      padding: $sided-layout-main-header-padding;
      background-color: $sided-layout-main-header-bg-color;

      .left-header {
        h4 {
          margin: $sided-layout-main-header-left-header-h4-margin;
          padding: $sided-layout-main-header-left-header-h4-padding;
          margin-top: $sided-layout-main-header-left-header-h4-margin-top;
        }
      }

      .right-header {
        text-align: $sided-layout-main-header-right-header-text-align;
      }
    }

    .form-content {

      .left-navbar {
        .outer-container {
          background-color: $sided-layout-main-content-outer-container-bg-color;
          min-height: $sided-layout-main-content-outer-container-min-height;
          border-radius: $sided-layout-main-content-outer-container-border-radius;
          padding: $sided-layout-main-content-outer-container-padding;
          max-height: $sided-layout-main-content-outer-container-max-height;
          overflow-y: auto;

          h6 {
            background-color: $sided-layout-main-content-outer-container-h6-bg-color;
            color: $sided-layout-main-content-outer-container-h6-color;
            border-bottom: $sided-layout-main-content-outer-container-h6-border-bottom;
            padding: $sided-layout-main-content-outer-container-h6-padding;
            margin-bottom: $sided-layout-main-content-outer-container-h6-margin-bottom;
          }

          .nav {
            .nav-item {
              border-bottom: .1em solid $secondary;
              margin-right: 0;

              a {
                padding: 0.7rem 0.7rem 0.7rem 1rem;
              }

              &:hover {
                cursor: pointer;
                color: rgb(0, 142, 206);
              }

              &.active {
                color: rgb(0, 142, 206);
                border-left: .25em solid $header-bg;

                a {
                  padding-left: 0.8rem;
                }
              }
            }
          }
        }
      }

      .content-placeholder {
        .outer-container {
          background-color: $sided-layout-main-content-content-placeholder-outer-container-bg-color;
          min-height: $sided-layout-main-content-content-placeholder-outer-container-min-height;
          border-radius: $sided-layout-main-content-content-placeholder-outer-container-border-radius;
          padding: $sided-layout-main-content-content-placeholder-outer-container-padding;

          .no-data-found {
            text-align: $sided-layout-main-content-content-placeholder-outer-container-no-data-found-text-align;
            font-size: $sided-layout-main-content-content-placeholder-outer-container-no-data-found-font-size;
            margin-top: $sided-layout-main-content-content-placeholder-outer-container-no-data-found-margin-top;
            color: $sided-layout-main-content-content-placeholder-outer-container-no-data-found-color;
          }
        }
      }
    }
  }
</style>
